__turbopack_context__.v({
  "attributesContainer": "styles-module__w8p8SW__attributesContainer",
  "hideMobile": "styles-module__w8p8SW__hideMobile",
  "scrollableItemRow": "styles-module__w8p8SW__scrollableItemRow",
  "scrollableItemRowVariant": "styles-module__w8p8SW__scrollableItemRowVariant",
  "similarItemsSashWrapper": "styles-module__w8p8SW__similarItemsSashWrapper",
});
